import { render, staticRenderFns } from "./CreateOfferTemplate.vue?vue&type=template&id=4288fd94"
import script from "./CreateOfferTemplate.vue?vue&type=script&lang=js"
export * from "./CreateOfferTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports